var map = {
	"./camera.svg": "6+d6",
	"./camera_circle.svg": "2YL3",
	"./camera_circle_blue.svg": "BTb5",
	"./camera_circle_green.svg": "1O8f",
	"./camera_circle_red.svg": "5BB8",
	"./camera_circle_yellow.svg": "6tgu",
	"./camera_lock.svg": "kTso",
	"./camera_lock_blue.svg": "1IkN",
	"./camera_lock_green.svg": "H1dI",
	"./camera_lock_red.svg": "jDzJ",
	"./camera_lock_yellow.svg": "tnA/",
	"./experience.svg": "hX8i",
	"./experience_circle.svg": "9+14",
	"./experience_circle_blue.svg": "zBrM",
	"./experience_circle_green.svg": "JOpJ",
	"./experience_circle_red.svg": "YCqp",
	"./experience_circle_yellow.svg": "b3Hv",
	"./experience_lock.svg": "bS5a",
	"./experience_lock_blue.svg": "njN0",
	"./experience_lock_green.svg": "yCfj",
	"./experience_lock_red.svg": "WimP",
	"./experience_lock_yellow.svg": "NLod",
	"./restaurant.svg": "mSQA",
	"./restaurant_circle.svg": "bIc6",
	"./restaurant_circle_blue.svg": "bEFS",
	"./restaurant_circle_green.svg": "dTSE",
	"./restaurant_circle_red.svg": "6Sxb",
	"./restaurant_circle_yellow.svg": "d9zk",
	"./restaurant_lock.svg": "bUfI",
	"./restaurant_lock_blue.svg": "INi4",
	"./restaurant_lock_green.svg": "6TZu",
	"./restaurant_lock_red.svg": "5RwN",
	"./restaurant_lock_yellow.svg": "CiYs",
	"./shopping.svg": "pT25",
	"./shopping_circle.svg": "q0TM",
	"./shopping_circle_blue.svg": "NFGI",
	"./shopping_circle_green.svg": "cRwd",
	"./shopping_circle_red.svg": "saWL",
	"./shopping_circle_yellow.svg": "JcPy",
	"./shopping_lock.svg": "B6bt",
	"./shopping_lock_blue.svg": "TXVI",
	"./shopping_lock_green.svg": "9tFu",
	"./shopping_lock_red.svg": "LAgx",
	"./shopping_lock_yellow.svg": "U0Hx",
	"./spa.svg": "TJUs",
	"./spa_circle.svg": "/DUA",
	"./spa_circle_blue.svg": "ukLU",
	"./spa_circle_green.svg": "H9Jv",
	"./spa_circle_red.svg": "uiN8",
	"./spa_circle_yellow.svg": "uSql",
	"./spa_lock.svg": "Ol0R",
	"./spa_lock_blue.svg": "f7NR",
	"./spa_lock_green.svg": "AOL4",
	"./spa_lock_red.svg": "KRSP",
	"./spa_lock_yellow.svg": "zRZb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8fdg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spots ^\.\/.*$
// module id = 8fdg
// module chunks = 0